import { numberFormatToPtBr } from '@/utils';

export const formatNumberWithSuffixesCompact = (number, limit = 9999) => {
  const paramAsNumber = Number(number);

  const avoidRoundingIntegerNumber = (value) => {
    if (value <= limit) return value;

    const [first, second] = numberFormatToPtBr(value).split('.');

    const numbersJoined = `${first}${String(second).charAt(0)}`;
    const getSizeFromRemainingValue = String(value).substring(numbersJoined.length).length;

    const transformRemainingValueInZeros = Array.from({ length: getSizeFromRemainingValue }, () => '0');

    return Number([...numbersJoined, ...transformRemainingValueInZeros].join(''));
  };

  const numberWithoutRounding = avoidRoundingIntegerNumber(paramAsNumber);

  if (numberWithoutRounding <= limit) return numberFormatToPtBr(number);

  const numberFormatted = Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,

  }).format(numberWithoutRounding);

  return numberFormatted.includes('K') ? numberFormatted.toLowerCase() : numberFormatted;
};
